import React, { useState, useEffect } from "react";
import "./cardPerfilUsu.css";
import { encode } from "base64-arraybuffer"; // Importa el paquete

import iconoEliminar from "../../img/iconoEliminar.png";
import iconoEditar from "../../img/iconoEditar.png";

import apiClient from '../../acciones/apiClient';

export const CardPerfilUsuario = ({ titulo, portada, proyectoId }) => {
    console.log('Portada recibida en CardPerfilUsuario:', portada); // Verifica la portada
    console.log('Título recibido:', titulo);
    console.log('ID del proyecto:', proyectoId);

    const [showModal, setShowModal] = useState(false);
    const [imagenBase64, setImagenBase64] = useState(null);

    useEffect(() => {
        console.log('Portada original:', portada); // Verifica el contenido de portada
        if (portada && portada.startsWith("data:image")) {
            // Si portada ya es base64, úsalo directamente
            setImagenBase64(portada);
        } else if (portada && portada.data) {
            // Si portada es un buffer o no está en base64, conviértelo
            const base64String = `data:image/jpeg;base64,${encode(portada.data)}`;
            setImagenBase64(base64String);
        }
    }, [portada]);

    const handleEliminarClick = () => {
        setShowModal(true);
    };

    const handleAceptar = async () => {
        try {
            await apiClient.delete(`/proyectos/${proyectoId}`);
            console.log("Proyecto eliminado");
            setShowModal(false);
            window.location.reload(); // Refresca la página después de eliminar
        } catch (error) {
            console.error("Error al eliminar el proyecto:", error);
        }
    };

    const handleCancelar = () => {
        setShowModal(false);
    };

    return (
        <div className="cardPerfilUsu">
            <a href={`/EditarProyecto/${proyectoId}`}>
                <img src={iconoEditar} alt="Editar" className="imgIconoEditar" />
            </a>
            <img
                src={iconoEliminar}
                alt="Eliminar"
                className="imgIconoEliminar"
                onClick={handleEliminarClick}
            />
            <img
                src={imagenBase64 || "/ruta/imagen/por/defecto.png"}
                alt={`Portada de ${titulo}`}
                className="imgPortada"
            />
            <h5>{titulo}</h5>

            {showModal && (
                <div className="modalCardPerfilUsu">
                    <div className="modal-content">
                        <p>¿Seguro que quiere borrar este proyecto?</p>
                        <button onClick={handleAceptar}>Aceptar</button>
                        <button onClick={handleCancelar}>Cancelar</button>
                    </div>
                </div>
            )}
        </div>
    )
}